import type { BillingFrequency } from '@proposify/pricing-engine';

export const pricingTableTotalsFooterTestIds = {
  oneTimeSubtotalTitle: 'one-time-subtotal-title',
  frequencySubtotalTitle: (frequency: BillingFrequency) => `frequency-subtotal-title-${frequency}`,
  frequencySubtotalRow: (frequency: BillingFrequency) => `frequency-subtotal-${frequency}-row`,
  frequencySubtotalValue: (frequency: BillingFrequency) => `value-frequency-subtotal-${frequency}`,
};
